import { Coordinate, Envelope } from './geometry';
export class ReferenceFrame {
    public Datum!: Coordinate;
    public InverseResolution!: number;
    public Resolution!: number;
    public Extent!: Envelope;
    public Width!: number;
    public Height!: number;
  
    public setFromData(minx: number, miny: number, cellSize: number, width: number, height: number) {
      const extwidth: number = width * cellSize;
      const extheight:number = height * cellSize;
      this.Extent = new Envelope(minx, miny, minx + extwidth, miny + extheight);
      this.InverseResolution = 1 / cellSize;
      this.Resolution = cellSize;
      this.Datum = new Coordinate(minx, miny);
      this.Width = width;
      this.Height = height;
  
    }
  }